import { NgModule } from '@angular/core';
import { GroupMappingComponent } from './group-mapping.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SalesintelPrettyFieldPipeModule } from '../../../pipes';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DisableAutocompleteDirectiveModule } from 'src/app/shared/directives';

@NgModule({
    imports: [
        DisableAutocompleteDirectiveModule,
        CommonModule,
        ReactiveFormsModule,
        SalesintelPrettyFieldPipeModule,
        MatSlideToggleModule,
    ],
    declarations: [GroupMappingComponent],
    exports: [GroupMappingComponent]
})
export class GroupMappingModule {}
